import React, { useContext } from 'react';
import { Col, Row } from 'antd';
import Title from 'components/BoxContainer/components/Title';

import styles from '../../styles.module.less';

import { ReportContext } from '@src/containers/App/TimeTracker/Main/contexts/ReportContext';
import { useIntl } from 'react-intl';
import { DateUtil } from '@src/packages/utils/dates';

const EditMarkDrawerSummary = () => {
  const intl = useIntl();

  const getMarking = type => {
    const dayMarking = selectedReportRecord?.workingDayMarking;
    if (!dayMarking) return '';

    if (type === 'start') {
      if (!dayMarking.includes('-')) return dayMarking;
      const mark = dayMarking.split('-')[0];
      return mark.trim();
    }
    if (type === 'end') {
      if (!dayMarking.includes('-')) return dayMarking;
      const mark = dayMarking.split('-')[1];
      return mark.trim();
    }
    return '';
  };

  const getTitle = () => {
    const translatedText = intl.formatMessage({
      id: 'timeTracker.reports.editMark.selectedMarking.title',
    });
    return `${translatedText} - ${DateUtil.standardFormatToDtFormat(selectedReportRecord?.date)}`;
  };
  const { selectedReportRecord } = useContext(ReportContext);
  return (
    <>
      <Title.SubTitle value={getTitle()} className="gx-mb-3 gx-pl-3" />
      <div className={`gx-mb-4 gx-mx-3 ${styles.userInfoSection}`}>
        <Row className={styles.userInfoRow}>
          <Col span={6}>
            {/* User name */}
            <div className={styles.userInfo}>
              <div className={styles.userInfo__label}>
                {intl.formatMessage({
                  id: 'timeTracker.reports.editMark.userInfo.name',
                })}
              </div>
              <div className={styles.userInfo__value}>
                {selectedReportRecord?.employee[0]?.value}
              </div>
            </div>
          </Col>

          <Col span={6}>
            {/* User rut */}
            <div className={styles.userInfo}>
              <div className={styles.userInfo__label}>
                {intl.formatMessage({
                  id: 'timeTracker.reports.editMark.userInfo.rut',
                })}
              </div>
              <div className={styles.userInfo__value}>
                {selectedReportRecord?.employee[1]?.value}
              </div>
            </div>
          </Col>

          <Col span={6}>
            <div className={styles.userInfo}>
              <div className={styles.userInfo__label}>
                {intl.formatMessage({
                  id: 'timeTracker.reports.editMark.userInfo.startMarking',
                })}
              </div>
              <div className={styles.userInfo__value}>{getMarking('start')}</div>
            </div>
          </Col>

          <Col span={6}>
            <div className={styles.userInfo}>
              <div className={styles.userInfo__label}>
                {intl.formatMessage({
                  id: 'timeTracker.reports.editMark.userInfo.endMarking',
                })}
              </div>
              <div className={styles.userInfo__value}>{getMarking('end')}</div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default EditMarkDrawerSummary;
